import { Button } from "@/common/elements/button"

type SignedOutProps = {
  onSignIn: () => Promise<void>
  isLoading: boolean
  errorMessage: string | null
}

export function SignedOut({ onSignIn, isLoading, errorMessage }: SignedOutProps) {
  return (
    <div className="relative grid min-h-svh bg-muted/30 md:grid-cols-2">
      <img
        src="/assets/cloudfit-logo.png"
        alt="CloudFit Software"
        className="absolute left-6 top-6 z-10 h-10 w-auto md:h-12"
        loading="lazy"
      />
      <div className="flex items-center justify-center p-6 md:p-10">
        <div className="w-full max-w-sm overflow-hidden rounded-2xl border border-border/70 bg-background/95 p-6 text-center shadow-[0_28px_70px_-40px_hsl(var(--foreground)/0.55)] backdrop-blur-sm sm:p-7">
          <div className="pointer-events-none -mx-6 -mt-6 mb-6 h-1 bg-[linear-gradient(90deg,var(--chart-1),var(--chart-3),var(--chart-5))] sm:-mx-7 sm:-mt-7" />
          <p className="text-xs font-semibold tracking-[0.22em] text-muted-foreground uppercase">Signed Out</p>
          <h1 className="mt-2 text-2xl font-semibold text-foreground sm:text-[1.75rem]">CloudFit Portal</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            Your CloudFit Portal session has ended.
          </p>
          {errorMessage ? (
            <p className="mt-6 rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-left text-sm text-destructive" role="alert">
              {errorMessage}
            </p>
          ) : null}
          <Button
            type="button"
            size="lg"
            className="mt-6 w-full text-sm font-semibold"
            disabled={isLoading}
            onClick={() => {
              void onSignIn()
            }}
          >
            {isLoading ? "Redirecting..." : "Sign in"}
          </Button>
        </div>
      </div>
      <div className="relative hidden md:block">
        <img
          src="/assets/login-team.jpg"
          alt="CloudFit team"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  )
}